import ToggleItem from './toggle_item';

export default class CellImage extends ToggleItem {
  constructor() {
    super('cellimage');
  }
}
